import { PERSISTED_CHART_KIND, isPipelineBuiltinChartKind, resolvePersistedChartKind, } from '../../statistics/charts/board/lib/statisticsPersistedCharts';
import { isYearMonthsLiveBundleRenderable } from '../../statistics/charts/board/lib/buildDashboardChartBundle';
import { rendersAsBuiltinLiveChart, rendersAsFrozenBuiltinChart } from '../../statistics/charts/board/lib/dashboardChartLifecycle';
export function isChartExplorerQueryLoading(bundle, snapshot) {
    if (!snapshot)
        return false;
    if (!bundle)
        return true;
    return Boolean(bundle.chartLoading ||
        bundle.trendChartLoading ||
        bundle.isStatisticsQueryLoading ||
        bundle.isStatisticsQueryFetching);
}
/** 是否已有可绘制数据（忽略 loading；内置图由子组件自行处理空态） */
export function hasChartExplorerDrawableData(bundle, snapshot) {
    if (!snapshot || !bundle)
        return false;
    const kind = resolvePersistedChartKind(snapshot);
    if (isPipelineBuiltinChartKind(kind) ||
        rendersAsBuiltinLiveChart(snapshot) ||
        rendersAsFrozenBuiltinChart(snapshot)) {
        return true;
    }
    if (kind === PERSISTED_CHART_KIND.OVERDUE) {
        const overdueData = bundle.overdueData;
        if (!overdueData)
            return false;
        return Object.keys(overdueData).some((key) => key !== '_meta');
    }
    if (kind === PERSISTED_CHART_KIND.COMPOSITION) {
        const matrix = bundle.compareSeriesMatrix;
        const stats = bundle.primaryPhaseStats;
        return Boolean(matrix?.length || (stats && Object.keys(stats).length > 0));
    }
    if (!isYearMonthsLiveBundleRenderable(bundle))
        return false;
    const compares = bundle.compares;
    const orders = bundle.orders;
    const periodYoy = bundle.trendPeriodYoy;
    const dimSeries = bundle.trendDimensionSeriesByMetric;
    if (periodYoy?.years?.length)
        return true;
    if (compares?.length)
        return true;
    if (orders?.length)
        return true;
    if (dimSeries && Object.values(dimSeries).some((series) => Array.isArray(series) && series.length > 0))
        return true;
    return false;
}
/** 进入详情 / 切图后的拉数：有请求在飞就出骨架，避免大数量时空白无反馈 */
export function isChartExplorerBundleLoading(bundle, snapshot) {
    if (!snapshot)
        return false;
    if (!bundle)
        return true;
    return isChartExplorerQueryLoading(bundle, snapshot);
}
/** 查数完成但当前筛选下无可绘制数据 */
export function isChartExplorerChartDataEmpty(bundle, snapshot) {
    if (!snapshot || !bundle)
        return false;
    if (isChartExplorerQueryLoading(bundle, snapshot))
        return false;
    return !hasChartExplorerDrawableData(bundle, snapshot);
}
